import { RouteRecordRaw } from 'vue-router';
import { FillLogsPage } from '@/pages/record-fill';

export const routeName = 'LogsDePreenchimento';

export const route: RouteRecordRaw = {
  path: 'registros-da-qualidade/:prefix/logs-de-preenchimento/:recordId',
  name: routeName,
  component: FillLogsPage,
  meta: {
    requiresAuth: true,
  },
};
